import React, { Component } from "react";

class LoadingInProgress extends Component {

  render() {
    return (
      <div style={{textAlign:'center', color:'#999'}}>
        <i className="far fa-refresh fa-3x fa-spin" />
        <div style={{marginTop:'10px'}}>{this.props.message}</div>
      </div>
    )
  }
}

export default LoadingInProgress;


